export const environment = {
    name: 'staging',
    production: false,
    url: 'https://cac-drbi.apps06.tic.gov.tl/api',
    captcha: '6LcgneAcAAAAAOVxYdEOiHE_LR7sb3-Kw5wBvAXn',
    manualUrl: 'http://cac.tl/wp-content/uploads/2022/02/Manual-Utilizador-Sistema-Deklarasaun-Rikusoin.pdf',
  };
